export default __webpack_public_path__ + "static/media/Khorajan Agha Quiver.aae07a6a.jpg";